<div class="head">
    <b>{{ title() }}</b>
    @if (range()) {
        <span class="range">{{ range() }}</span>
    }
    <span class="total">{{ total() }}</span>
    <span class="target">/ {{ target() }}</span>
</div>
<div class="days">
    @for (day of view(); track $index) {
        <div (dblclick)="openableDays() && dayDblClick.emit(day)"
             [class.openable]="openableDays()"
             [class.today]="day.today"
             [class.weekend]="day.weekend"
             [matTooltipShowDelay]="300"
             [matTooltip]="day.tooltip ?? ''"
             [style.background]="day.background || null"
             class="day">
            <span class="label">{{ day.label }}</span>
            <span [class.missing]="day.missing" [class.short]="day.short" class="bar">
                <span [style.height.%]="day.height" class="fill"></span>
                <span class="value">{{ day.value }}</span>
            </span>
        </div>
    }
</div>
